import React, { useMemo } from 'react';
import { getAmountWithCurrency } from '@pascal/pascal-core';
import { freeBetsWinTypes, globalTranslationKeys } from '../../../../../../enums';
import { getOdd, getProbabilityOfRange } from '../../../../../../helpers';
import { minus, multiply, toFixed } from '../../../../../../helpers/arithmeticOperations';

const BetSectionHeader = ({ t, range, betAmount, activeFreeBet, setCurrentWinOdd }) => {
  const { Chance, Odd, Payout } = globalTranslationKeys;
  const { winType } = activeFreeBet;
  const { win } = freeBetsWinTypes;
  const [start, end] = range;

  const getCurrentWinOdd = useMemo(() => {
    const currentWinOdd = toFixed(getOdd(start, end), 3);
    setCurrentWinOdd(currentWinOdd);
    return currentWinOdd;
  }, [start, end]);

  const getCurrentChance = useMemo(() => {
    return toFixed(getProbabilityOfRange(start, end), 3);
  }, [start, end]);

  const calculateWinAmountByOdd = useMemo(() => {
    return toFixed(multiply(getCurrentWinOdd, +betAmount), 2);
  }, [start, end, betAmount]);

  return (
    <div className='b-s-payout-wrp'>
      <div className='b-s-payout-clm'>
        <p className='b-s-payout-txt' title={t(Odd)}>
          {t(Odd)}
        </p>
        <p className='b-s-payout-number'>x{getCurrentWinOdd}</p>
      </div>
      <div className='b-s-payout-clm'>
        <p className='b-s-payout-txt' title={t(Payout)}>
          {t(Payout)}
        </p>
        <p className='b-s-payout-number'>
          {getAmountWithCurrency({
            amount:
              activeFreeBet?.id && winType === win
                ? toFixed(minus(calculateWinAmountByOdd, +betAmount), 2)
                : calculateWinAmountByOdd || toFixed(multiply(getCurrentWinOdd, +betAmount), 4),
          })}
        </p>
      </div>
      <div className='b-s-payout-clm'>
        <p className='b-s-payout-txt' title={t(Chance)}>
          {t(Chance)}:
        </p>
        <p className='b-s-payout-number'>{getCurrentChance}%</p>
      </div>
    </div>
  );
};

export default BetSectionHeader;
